export default __webpack_public_path__ + "96c0b6026d440c530436903b82dd03c9.png";